/* TinaR – măsurarea folosirii calculatorului (13 oct 2026). Nu modifică tinar-fit.js.
   Evenimente trimise cu Shopify.analytics.publish (le preia un Custom pixel din Settings → Customer events):
     tinar_fit_afisat   – blocul „Verifică potrivirea” e vizibil pe pagină
     tinar_fit_deschis  – clienta a deschis blocul (o dată pe pagină)
     tinar_fit_rezultat – clienta a apăsat „Verifică potrivirea” și a primit un rezultat
   Date trimise: sku (părinte), multi, verdict (bine/stramt/larg), recomandat (mărimea), mod (masuri/marime).
   Măsurile clientei NU se trimit.
   Marcaj pe comandă: câmp ascuns properties[_Calculator] în formularul de produs, ex. „folosit | recomandat M | bine”,
   sau „vazut | …” când rezultatul a fost restaurat automat din vizita anterioară și clienta a deschis blocul.
   Notă: tinar-fit.js trimite separat „tinar_fit_check”, inclusiv la restaurarea automată (nu se folosește în raport). */
(function () {
  "use strict";
  function pub(n, d) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d); } catch (e) {} }
  function info(box) { try { return JSON.parse(box.querySelector("[data-tinar-fit-json]").textContent) || {}; } catch (e) { return {}; } }
  function result(box) {
    var v = box.querySelector(".tf-result .tf-verdict"); if (!v) return null;
    var m = /tf-(bine|stramt|larg)/.exec(v.className), best = box.querySelector(".tf-sizes .tf-best b");
    return { verdict: m ? m[1] : "", recomandat: best ? best.textContent.trim() : "" };
  }
  function forms(box) {
    var sec = box.closest("[id^='shopify-section']"), f = sec ? sec.querySelectorAll("form[action*='/cart/add']") : [];
    if (!f.length) { var one = document.querySelector("form[action*='/cart/add']"); f = one ? [one] : []; }
    return f;
  }
  function mark(box, val) {
    Array.prototype.forEach.call(forms(box), function (f) {
      var i = f.querySelector("input[name='properties[_Calculator]']");
      if (!i) { i = document.createElement("input"); i.type = "hidden"; i.name = "properties[_Calculator]"; f.appendChild(i); }
      i.value = val;
    });
  }
  function label(kind, r) { return [kind, r.recomandat ? "recomandat " + r.recomandat : "", r.verdict].filter(Boolean).join(" | "); }
  function setup(box) {
    if (box.__tfTrack) return; box.__tfTrack = true;
    if (box.hidden || box.style.display === "none") return;
    var d = info(box), base = { sku: d.parent || "", multi: !!d.multi }, det = box.querySelector("details"), opened = false, used = false;
    pub("tinar_fit_afisat", base);
    if (det) det.addEventListener("toggle", function () {
      if (!det.open) return;
      if (!opened) { opened = true; pub("tinar_fit_deschis", base); }
      var r = result(box); if (r && !used) mark(box, label("vazut", r));
    });
    box.addEventListener("submit", function (e) {
      var manual = e.isTrusted;
      setTimeout(function () {
        var r = result(box); if (!r) return;
        if (manual) {
          used = true;
          var t = box.querySelector(".tf-tabs [aria-selected='true']");
          pub("tinar_fit_rezultat", { sku: base.sku, multi: base.multi, verdict: r.verdict, recomandat: r.recomandat, mod: t ? t.getAttribute("data-mode") : "" });
          mark(box, label("folosit", r));
        } else if (det && det.open && !used) mark(box, label("vazut", r));
      }, 0);
    }, true);
  }
  function run() { document.querySelectorAll("[data-tinar-fit]").forEach(setup); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
